import { getTranslatedText, useIntl } from '@nile/components';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function SurveyTypeCell(props) {
  const { data } = props;
  const intl = useIntl();
  const SURVEY_TYPE = {
    THUMBSUP: getTranslatedText(
      intl,
      'admin.customerSatisfaction.binaryRating.type'
    ),
    FIVE_STAR: getTranslatedText(
      intl,
      'admin.customerSatisfaction.fiveStarRating.type'
    )
  };
  return (
    <>
      {data ? (
        <TextStyle>{SURVEY_TYPE[data] || data}</TextStyle>
      ) : (
        <FormattedMessage id="app.noData.message" />
      )}
    </>
  );
}

export default SurveyTypeCell;
